"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHubSettings = getHubSettings;
exports.updateHubSettings = updateHubSettings;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var HUBS_SETTINGS_PATH = 'hubs/v1/settings';

var portalId = _hubspot.default.get();

function getHubSettings() {
  return _apiClient.default.get(HUBS_SETTINGS_PATH, {
    query: {
      portalId: portalId
    }
  });
}

function updateHubSettings(key, value) {
  return _apiClient.default.post(HUBS_SETTINGS_PATH, {
    query: {
      portalId: portalId
    },
    data: {
      hubId: portalId,
      key: key,
      value: value,
      internal: false
    }
  });
}